import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Link, generatePath } from 'react-router-dom';

import { SystemRoutePath } from 'applications/GSP/shared/constants/router';
import { InformationSection as SharedInformationSection } from 'shared/components/Disclaimer';

import type { FC } from 'react';

export const InformationSection: FC = () => {
  const { t } = useTranslation();

  const cookiePolicyLink = (
    <Link to={generatePath(SystemRoutePath.CookiesPolicy)} />
  );
  const privacyPolicyLink = (
    <Link to={generatePath(SystemRoutePath.PrivacyNotice)} />
  );

  return (
    <SharedInformationSection>
      <Typography marginTop={2} marginBottom={2} variant="h6">
        {t('GSP.features.cookiesPreferences.header')}
      </Typography>
      <Typography variant="body1">
        <Trans
          i18nKey="GSP.features.cookiesPreferences.description.p1"
          components={{ cookiePolicyLink, privacyPolicyLink }}
        />
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {t('GSP.features.cookiesPreferences.description.p2')}
      </Typography>
    </SharedInformationSection>
  );
};
